import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1381e2ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-secondary" }, [
  /*#__PURE__*/_createElementVNode("span", null, "open modal")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "fullscreen-modal",
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_3 = {
  class: "fullscreen-modal__dialog",
  ref: "modalRef"
}
const _hoisted_4 = {
  key: 0,
  class: "loading-overlay d-flex align-items-center justify-content-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner__item loading-spinner__item--1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner__item loading-spinner__item--2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner__item loading-spinner__item--3" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "fullscreen-modal__content" }
const _hoisted_8 = { class: "fullscreen-modal-header" }
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close btn-link-grey__icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = { class: "visually-hidden" }
const _hoisted_12 = { class: "fullscreen-modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "button", { show: _ctx.show }, () => [
      _hoisted_1
    ], true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        name: "fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.showModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "fullscreen-modal__backdrop",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }),
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        (_ctx.title)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.title), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.$translate('rent_site.booking-widget.overlay.title')), 1)
                            ], 64))
                      ]),
                      _createElementVNode("button", {
                        class: "btn-no-styling btn-link-grey fullscreen-modal-header__close",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                        title: _ctx.$translate('rent_site.close.button')
                      }, [
                        _hoisted_10,
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$translate('rent_site.close.button')), 1)
                      ], 8, _hoisted_9)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["fullscreen-modal__body", _ctx.bodyModifier])
                    }, [
                      _renderSlot(_ctx.$slots, "content", {}, undefined, true)
                    ], 2),
                    _createElementVNode("div", _hoisted_12, [
                      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                    ])
                  ])
                ], 512)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 64))
}